import React from "react";
import { format } from "date-fns";
import get from "lodash/get";
import { object, string } from "prop-types";

import "./key-events.m.css";

const getEvents = (cards = []) => {
  return cards
    .filter(card => get(card, ["metadata", "attributes", "key-event"], false))
    .map(card => {
      const titleElement = card["story-elements"].find(({ type }) => type === "title");

      if (titleElement) {
        return {
          ...titleElement,
          "card-id": card.id,
          "card-added-at": card["card-added-at"]
        };
      }
    });
};

const KeyEvents = ({ story, displayOrder }) => {
  const events = getEvents(story.cards);

  if (!events.length) return null;

  return (
    <div styleName="wrapper">
      <div styleName="event-title">KEY EVENTS</div>
      <div styleName="events">
        <ul styleName={`events-list ${displayOrder === "old" ? "reverse" : ""}`}>
          {events.map(event => {
            return (
              <li key={event["card-id"]}>
                <a href={`#live-blog-card-${event["card-id"]}`}>
                  <h3 styleName="event-date">{format(event["card-added-at"], "h:mm a, dd MMM")}</h3>
                  <span styleName="event-content">{event.text}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

KeyEvents.propTypes = {
  story: object,
  displayOrder: string
};

export default KeyEvents;
